import Footer from "./main/Footer";
import Header from "./main/Header";
import { Outlet } from "react-router-dom";

export default function Layout() {
  return (
    <>
      <div className="flex flex-col min-h-screen">
        <Header />
        <div className="w-full flex-1 pt-0 pb-0">{<Outlet />}</div>
        <Footer />
      </div>
    </>
  );
}
